import { render, staticRenderFns } from "./alarm-set.vue?vue&type=template&id=30654142"
import script from "./alarm-set.vue?vue&type=script&lang=ts"
export * from "./alarm-set.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports